/**
 * Author:  LiShibin.
 * Date:    2016/9/22.
 * File：   webpack-dev-middlewar 插件的代理，ehome接口的post请求.
 */
import * as axios from 'axios'
import getHead from './getHead'
import {getErrorCn} from './errorMap'
import {isEmptyObject} from '../util'
import MessageBox from '@/components/message'

/**
 * 基于axios,自定义的post方法
 * @param type oauth/inner/outer
 * @param url
 * @param data
 * @param responseType
 * @param sec
 * @returns {Promise}
 */
async function post (type, url, data, sec, responseType) {
  const _type = responseType
  sec = sec ? 'true' : 'false'
  responseType = responseType ? _type : ''
  // console.debug('请求参数：')
  // console.debug(data)
  let serverHost = localStorage.getItem('serverHost')
  let eHomeServerHost = localStorage.getItem('eHomeServerHost')
  let serverPort = localStorage.getItem('serverPort')
  let serverPortSB = localStorage.getItem('serverPortSB')
  let serverPortOuter = localStorage.getItem('serverPortOuter')
  let serverPortInner = localStorage.getItem('serverPortInner')
  let serverPortOauth = localStorage.getItem('serverPortOauth')
  /**
   * 支持跨域直接访问请求服务器 qt使用
   */
  let proxyUrl = ''
  switch (type) {
    case 'outer':
      proxyUrl = eHomeServerHost + ':' + serverPortOuter
      break
    case 'workflow':
      proxyUrl = eHomeServerHost + ':9100'
      break
    case 'inner':
      proxyUrl = eHomeServerHost + ':' + serverPortInner
      break
    case 'oauth':
      proxyUrl = eHomeServerHost + ':' + serverPortOauth
      break
    case 'swagger':
      proxyUrl = serverHost + ':' + serverPort + url
      break
    case 'swaggerSB':
      proxyUrl = serverHost + ':' + serverPortSB + url
      break
    default:
      proxyUrl = serverHost + ':9000'
      break
  }
  let head = await getHead(type, url, data)
  data = (['swagger', 'swaggerSB'].indexOf(type) < 0) ? encodeURIComponent(JSON.stringify(data)) : data
  return new Promise((resolve, reject) => {
    axios.post(proxyUrl, data, {headers: head, responseType}).then(function (response) {
      if (!isEmptyObject(response.data)) {
        if (type !== 'swagger' && type !== 'swaggerSB') {
          let str = response.data.replace(/\+/g, '%20')// 解决空格变成加号的问题
          response.data = decodeURIComponent(str)
          response.data = response.data.replace(/\t/g, '')// 解决制表符影响json解析的问题
        }
        // console.debug('请求结果：')
        // console.debug(response.data)
        // 由于接口设计问题，部分错误会返回一个 ERR_开头的异常信息字符串,如：ERR_{code:'',msg:''}
        if (/ERR_/.test(response.data)) {
          let errorJson = JSON.parse(response.data.replace('ERR_{', '{'))
          // 判断是否超时，跳转到登录
          if (errorJson.code === '3004') {
            MessageBox('提示', '登录超时，请重新登录！')
          }
          // 将英文错误提示映射为中文
          let errorCn = getErrorCn(errorJson.msg)
          if (errorCn) {
            errorJson.msg = errorCn
          }
          MessageBox('提示', errorJson.msg)
          reject(new Error(JSON.stringify(errorJson)))
        } else if (response.data == null || response.data === '') {
          MessageBox('提示', '请求无响应')
          reject(new Error({code: '4040', msg: '请求无响应'}))
        } else {
          let responseData = (type !== 'swagger' && type !== 'swaggerSB') ? JSON.parse(response.data) : response.data
          // 同时出现code与msg,说明服务端响应的是异常信息
          if (typeof responseData.code !== 'undefined' && typeof responseData.msg !== 'undefined') {
            // 将英文错误提示映射为中文
            let errorCn = getErrorCn(responseData.msg)
            if (errorCn) {
              responseData.msg = errorCn
            }
            MessageBox('提示', responseData.msg)
            reject(new Error(responseData))
          } else {
            // 正常响应处理
            resolve(responseData)
          }
        }
      } else {
        resolve(response.data)
      }
    }).catch(function (error) {
      console.error('请求服务器发生错误：')
      console.error(error)
      MessageBox('提示', '请求失败')
      reject(new Error({code: '4040', msg: '请求失败'}))
    })
  })
}

export default post



// WEBPACK FOOTER //
// ./src/post/post-proxy.js